const formatTel = tel => {
    if (tel) {
        return tel.replace(/ /g, '').replace(/\+/g, '')
    }
    return tel
}

export { formatTel }
